var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F2FAF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3334 9.51265V12.2663C17.3334 12.6397 17.3334 12.8264 17.4061 12.969C17.47 13.0944 17.572 13.1964 17.6974 13.2603C17.84 13.333 18.0267 13.333 18.4001 13.333H21.1538M21.3334 14.6585V19.4663C21.3334 20.5864 21.3334 21.1465 21.1154 21.5743C20.9237 21.9506 20.6177 22.2566 20.2414 22.4484C19.8136 22.6663 19.2535 22.6663 18.1334 22.6663H13.8667C12.7466 22.6663 12.1866 22.6663 11.7588 22.4484C11.3824 22.2566 11.0765 21.9506 10.8847 21.5743C10.6667 21.1465 10.6667 20.5864 10.6667 19.4663V12.533C10.6667 11.4129 10.6667 10.8529 10.8847 10.425C11.0765 10.0487 11.3824 9.74274 11.7588 9.55099C12.1866 9.33301 12.7466 9.33301 13.8667 9.33301H16.0079C16.4971 9.33301 16.7417 9.33301 16.9719 9.38827C17.176 9.43726 17.371 9.51807 17.55 9.62773C17.7518 9.75141 17.9248 9.92436 18.2707 10.2703L20.3962 12.3957C20.7421 12.7417 20.915 12.9146 21.0387 13.1164C21.1484 13.2954 21.2292 13.4905 21.2782 13.6945C21.3334 13.9247 21.3334 14.1693 21.3334 14.6585Z",
    stroke: "#4C877F",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile04);
export default __webpack_public_path__ + "static/media/file-04.5eca2d206395e1dba0e4ba08ae966be3.svg";
export { ForwardRef as ReactComponent };